import EditPromoPage from './EditPromoPage';

export default EditPromoPage;
